import { InMemoryDbService } from 'angular-in-memory-web-api';

import { AcademyFakeDb } from './academy';
import { CertifFakeDb } from './certificarBD';
import { ChatFakeDb } from './chat';
import { TodoFakeDb } from './todo';
import { ProjectDashboardDb } from './dashboard-project';
import { AnalyticsDashboardDb } from './dashboard-analytics';

export class FakeDbService implements InMemoryDbService
{
    createDb(): any
    {
        return {
            // Academy
            'academy-categories': AcademyFakeDb.categories,
            'academy-courses'   : AcademyFakeDb.courses,
            'academy-course'    : AcademyFakeDb.course,

            // certificar
            'certificar-categories': CertifFakeDb.categories,
            'certificar-courses'   : CertifFakeDb.courses,
            'certificar-course'    : CertifFakeDb.course,

            // Chat
            'chat-contacts': ChatFakeDb.contacts,
            'chat-chats'   : ChatFakeDb.chats,
            'chat-user'    : ChatFakeDb.user,

            // Todo
            'todo-todos'  : TodoFakeDb.todos,
            'todo-filters': TodoFakeDb.filters,
            'todo-tags'   : TodoFakeDb.tags,

            // Dashboards
            'project-dashboard-projects' : ProjectDashboardDb.projects,
            'project-dashboard-widgets'  : ProjectDashboardDb.widgets,
            'analytics-dashboard-widgets': AnalyticsDashboardDb.widgets
        };
    }
}
